import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'app-admin-actions-header',
    templateUrl: './admin-actions-header.component.html',
    styleUrls: ['./admin-actions-header.component.scss'],
    standalone: false
})
export class AdminActionsHeaderComponent {
  @Output() onExportToXls: EventEmitter<void> = new EventEmitter<void>();
  @Output() onExportToPdf: EventEmitter<void> = new EventEmitter<void>();
  @Input() isXlsVisible: boolean = true;
  @Input() isPdfVisible: boolean = true;
  @Input() trailingWidgetHolderClass: string | undefined;

  exportToXls() {
    this.onExportToXls.emit();
  }

  exportToPdf() {
    this.onExportToPdf.emit();
  }
}
